import {
  AzureIdentityProvider
} from './immi';

import { config } from '@/config/env';
import { FORCE_TENANCY } from '@/config/constants';
import { getActiveTenancy, reconcileActiveTenancy } from '@/features/tenancy';

let authProvider;
switch (config.AUTH_TYPE) {
  case 'azure':
  case 'azure-b2c':
    console.log('[AuthProvider] Using Azure Identity Provider');
    authProvider = AzureIdentityProvider({
      b2c: config.AUTH_TYPE === 'azure-b2c' ? true : false,
      authenticatedRedirectPath: '/',
      endpoint: config.AUTH_ENDPOINT,
      client_id: config.AUTH_CLIENT_ID,
      header_key: config.AUTH_HEADER,
      scope: config.AUTH_SCOPE,
      //additionalInformationCheck: config.BACKEND_URL + '/auth/me',
      customHeaders: (headers) => {
        const tenancy = getActiveTenancy();
        if (tenancy) {
          headers['X-TENANCY'] = tenancy;
        }
        return headers;
      },
      getBackendUrl: (user) => {
        return config.BACKEND_URL;
      },
      onAfter: (user, token) => {
        // Refresh claims may be empty, partial, or reordered. They must never
        // invalidate an existing tab-scoped selection.
        reconcileActiveTenancy(user.groups, FORCE_TENANCY, user.id);
      }
    });
    break;
  default:
    throw new Error(`Unknown AUTH_TYPE: ${config.AUTH_TYPE}`);
}

export default authProvider;
